export const elementsUndoOrigin = 'elementsUndoOrigin';
export const backgroundElementsUndoOrigin = 'backgroundElementsUndoOrigin';